module.exports = __webpack_public_path__ + "static/media/ios-arrow-dropup-circle.38670abd.svg";